import { CognitoUserPool } from 'amazon-cognito-identity-js';

let userPool: CognitoUserPool | null = null;

try {
  console.log('Initializing Cognito User Pool...');

  // HoneyDo Cognito configuration - MUST be set via environment variables
  const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID;
  const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;

  if (!userPoolId || !clientId) {
    throw new Error(
      'Missing Cognito configuration: REACT_APP_COGNITO_USER_POOL_ID and REACT_APP_COGNITO_CLIENT_ID must be set. ' +
      'This environment is not properly configured.'
    );
  }

  console.log('Cognito config:', { userPoolId, clientId });

  const poolData = {
    UserPoolId: userPoolId,
    ClientId: clientId
  };

  userPool = new CognitoUserPool(poolData);
  console.log('Cognito User Pool initialized successfully');
} catch (error) {
  console.error('Failed to initialize Cognito User Pool:', error);
  // Don't throw here, let the StatusProvider handle the null userPool case
}

export default userPool;
